import { useQuery } from "@tanstack/react-query";
import { http } from "../../../utils";

export async function fetchInquiryById(id) {
  const { data } = await http(`/admin/inquiry/${id}`);

  return data;
}

export function useInquiryById(id) {
  const { data, ...raResult } = useQuery(["inquiry-detail", id], () =>
    fetchInquiryById(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}



export async function fetchInquiryDownload(id) {
  const { data } = await http(`/admin/inquiries/${id}/attachs-download`, {
    responseType: "blob",
  });

  return data;
}

export function useAttachDownload(id) {
  const { data, ...raResult } = useQuery(["attachs-download", id], () =>
  fetchInquiryDownload(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}

